import React from "react"
import styles from "../styles/components/diamondCard.module.scss"

const DiamondCard = ({ info }) => {
  return (
    <div className={styles.card}>
      <img src={info.icon} alt="Diamond Membership Icon" />
      <h3 className={styles.title}>
        {info.type} <br />
        <span>Membership</span>
      </h3>
      <div className={styles.features}>
        {info.features.map((f, i) => (
          <p key={i} className={styles.feature}>
            {f}
          </p>
        ))}
      </div>
      <div className={styles.priceBox}>
        <p></p>
        {info.prices?.map((p, i) => (
          <p key={i}>
            {p.desc}: <br />
            <span>{p.price}</span>
          </p>
        ))}
        <p className={styles.condition}>{info.conditions}</p>
      </div>
      <div className={styles.duration}>
        <p>Time Duration:</p>
        <p className={styles.time}>{info.time}</p>
      </div>
    </div>
  )
}

export default DiamondCard
